var _defs, _rect, _g, _g2, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumericalAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f59e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ef4444"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 480,
    rx: 24,
    fill: "url(#grad2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.75)",
    fontFamily: "'Manrope', 'Segoe UI', sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 180,
    fontSize: 46,
    fontWeight: 700
  }, "Numerical"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 240,
    fontSize: 46,
    fontWeight: 700
  }, "Analysis"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.55)",
    fontFamily: "'Fira Code', monospace",
    fontSize: 22
  }, /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 330
  }, "\u2202f/\u2202x"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 360
  }, "\u2248"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 390
  }, "(f(x+h)-f(x))/h"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 80,
    height: 10,
    rx: 5,
    fill: "rgba(255,255,255,0.6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 115,
    width: 120,
    height: 10,
    rx: 5,
    fill: "rgba(255,255,255,0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumericalAnalysis);
export default __webpack_public_path__ + "static/media/numerical-analysis.8ff46b9851d4b5c3e3820968943e871e.svg";
export { ForwardRef as ReactComponent };